import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

import GettingStarted from "../components/GettingStarted"
import BannerPlace from "../components/BannerPlace"
import AppInfo from "../components/AppInfo"
import CardOffered from "../components/CardOffered"
import InstagramWidget from "../components/InstagramWidget"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <GettingStarted />
    <BannerPlace />
    <AppInfo />
    <CardOffered />
    <InstagramWidget />
  </Layout>
)

export default IndexPage
